export default function Logo({ light = false, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <span className="block h-7 w-[52px] sm:h-8 sm:w-[60px] shrink-0">
        <img
          src="/assets/logo.png"
          alt="Back Of The Mind logo"
          data-testid="brand-logo-image"
          draggable="false"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            display: "block",
            ...(light ? { filter: "brightness(1.45)" } : {}),
          }}
        />
      </span>
      <span
        className={`font-serif text-lg sm:text-xl tracking-tight leading-none ${
          light ? "text-cream" : "text-pine"
        }`}
      >
        Back <span className="italic">of</span> the Mind
      </span>
    </span>
  );
}
